import { ActionTypes } from '../actionTypes'
import { ContactsOthers, ContactsOthersActionTypes } from './types'

const initialState: ContactsOthers = {
  nameKanji: {
    sei: '',
    mei: '',
  },
  nameKana: {
    sei: '',
    mei: '',
  },
  mail: '',
  phoneNumber: '',
  storeName: '',
  contactsDetail: '',
  noReply: false,
}

export const ContactsOthersReducer = (
  state = initialState,
  action: ContactsOthersActionTypes
): ContactsOthers => {
  switch (action.type) {
    case ActionTypes.contactsOthers:
      return {
        ...state,
        nameKanji: action.payload.nameKanji,
        nameKana: action.payload.nameKana,
        mail: action.payload.mail,
        phoneNumber: action.payload.phoneNumber,
        storeName: action.payload.storeName,
        contactsDetail: action.payload.contactsDetail,
        noReply: action.payload.noReply,
      }
    case ActionTypes.clearState:
      return (state = initialState)
    default:
      return state
  }
}
